<template>
  <v-dialog v-model="interno" max-width="1200px" scrollable>
    <v-card>
      <v-card-title class="text-subtitle-1">
        Recomendados
        <v-spacer></v-spacer>
        <v-btn icon @click="interno = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense class="mb-2">
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Alumnos</div>
              <div class="text-h6 font-weight-bold">{{ kpi.alumnos_recomendadores || 0 }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Referidos</div>
              <div class="text-h6 font-weight-bold">{{ kpi.total_recomendados || 0 }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Pagaron</div>
              <div class="text-h6 font-weight-bold green--text">{{ kpi.total_pagados || 0 }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Sin pago</div>
              <div class="text-h6 font-weight-bold">{{ kpi.total_pendientes || 0 }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Conversión</div>
              <div class="text-h6 font-weight-bold">{{ kpi.conversion || 0 }}%</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card outlined class="pa-3 text-center">
              <div class="text-caption grey--text">Descuento</div>
              <div class="text-h6 font-weight-bold">${{ kpi.descuento_aplicado || 0 }}</div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="escuela"
              :items="escuelas"
              label="Escuela"
              filled
              dense
              hide-details
              @change="cargar"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="filtroPago"
              :items="opcionesPago"
              label="Pago de referidos"
              filled
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="6">
            <v-text-field
              v-model="buscar"
              label="Buscar alumno o matrícula"
              filled
              dense
              hide-details
              append-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="filtrados"
          :loading="cargarTabla"
          dense
          class="elevation-0 mt-4"
          :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
        >
          <template v-slot:item.total_recomendados="{ item }">
            <v-btn
              color="primary"
              small
              dark
              @click="abrirDetalle(item)"
            >
              {{ item.total_recomendados }}
            </v-btn>
          </template>
          <template v-slot:item.total_pagados="{ item }">
            <span class="font-weight-medium">{{ item.total_pagados }} / {{ item.total_recomendados }}</span>
          </template>
          <template v-slot:item.descuento_aplicado="{ item }">
            ${{ item.descuento_aplicado }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDetalle" max-width="800px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Referidos de {{ alumnoDetalle.alumno }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalle = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-caption grey--text mb-3">{{ alumnoDetalle.matricula }}</div>
          <v-data-table
            :headers="headersDetalle"
            :items="detalle"
            :loading="cargarDetalle"
            dense
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.pagado_texto="{ item }">
              <v-chip x-small dark :color="item.pagado ? 'green' : 'grey'">
                {{ item.pagado_texto }}
              </v-chip>
            </template>
            <template v-slot:item.descuento_aplicado="{ item }">
              ${{ item.descuento_aplicado }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: { type: Boolean, default: false },
    },

    data () {
      return {
        cargarTabla: false,
        cargarDetalle: false,
        escuela: 0,
        filtroPago: 'todos',
        buscar: '',
        items: [],
        kpi: {},
        dialogDetalle: false,
        alumnoDetalle: {},
        detalle: [],
        escuelas: [
          { text: 'Todas', value: 0 },
          { text: 'INBI', value: 1 },
          { text: 'FAST', value: 2 },
        ],
        opcionesPago: [
          { text: 'Todos', value: 'todos' },
          { text: 'Con al menos un pago', value: 'con_pago' },
          { text: 'Sin pagos', value: 'sin_pago' },
        ],
        headers: [
          { text: 'Alumno', value: 'alumno' },
          { text: 'Matrícula', value: 'matricula' },
          { text: 'Escuela', value: 'escuela_texto' },
          { text: 'Cuántos recomendó', value: 'total_recomendados' },
          { text: 'Pagaron', value: 'total_pagados' },
          { text: 'Descuento aplicado', value: 'descuento_aplicado' },
        ],
        headersDetalle: [
          { text: 'Prospecto', value: 'prospecto' },
          { text: 'Folio', value: 'folio' },
          { text: 'Teléfono / Twilio', value: 'telefono' },
          { text: '¿Pagó?', value: 'pagado_texto' },
          { text: 'Descuento', value: 'descuento_aplicado' },
        ],
      }
    },

    computed: {
      interno: {
        get () { return this.value },
        set (val) { this.$emit('input', val) },
      },
      filtrados () {
        let rows = this.items
        if (this.filtroPago === 'con_pago') {
          rows = rows.filter((row) => row.total_pagados > 0)
        }
        if (this.filtroPago === 'sin_pago') {
          rows = rows.filter((row) => row.total_pagados === 0)
        }
        const q = String(this.buscar || '').trim().toLowerCase()
        if (q) {
          rows = rows.filter((row) => (
            String(row.alumno || '').toLowerCase().includes(q)
            || String(row.matricula || '').toLowerCase().includes(q)
            || String(row.id_alumno || '').includes(q)
          ))
        }
        return rows
      },
    },

    watch: {
      value (val) {
        if (val) this.cargar()
      },
    },

    methods: {
      cargar () {
        this.cargarTabla = true
        const params = {}
        if (this.escuela) params.escuela = this.escuela
        this.$http.get('referrals.admin', { params }).then((response) => {
          this.items = (response.data && response.data.items) || []
          this.kpi = (response.data && response.data.kpi) || {}
        }).catch((error) => {
          this.items = []
          this.kpi = {}
          this.$emit('error', (error.response && error.response.data && error.response.data.message) || 'No se pudieron cargar los recomendados')
        }).finally(() => {
          this.cargarTabla = false
        })
      },

      abrirDetalle (item) {
        this.alumnoDetalle = item
        this.dialogDetalle = true
        this.cargarDetalle = true
        this.detalle = []
        this.$http.get('referrals.admin.detalle/' + item.id_alumno).then((response) => {
          this.detalle = (response.data && response.data.items) || []
        }).catch(() => {
          this.detalle = []
        }).finally(() => {
          this.cargarDetalle = false
        })
      },
    },
  }
</script>
